import { createI18n } from 'vue-i18n';
import messages from './messages.json';
import datetimeFormats from './dateTimeFormats';

export default createI18n({
  legacy: true,
  allowComposition: true,
  locale: 'en',
  messages,
  datetimeFormats,
});
